<a style="cursor: pointer" id="layout-config-button" class="layout-config-button" (click)="onConfigButtonClick($event)">
    <i class="pi pi-cog"></i>
</a>

<div class="layout-config" style="z-index: 1000;" [ngClass]="{'layout-config-active': app.configActive}" (click)="app.onConfigClick()">

    <h5>Color Scheme</h5>
    <div class="field-radiobutton">
        <p-radioButton name="darkMode" value="light" [(ngModel)]="app.darkMode" inputId="darkMode1"
                       (onClick)="changeColorScheme('light')"></p-radioButton>
        <label for="darkMode1">Light</label>
    </div>
    <div class="field-radiobutton">
        <p-radioButton name="darkMode" value="dark" [(ngModel)]="app.darkMode" inputId="darkMode2"
                       (onClick)="changeColorScheme('dark')"></p-radioButton>
        <label for="darkMode2">Dark</label>
    </div>

    <hr />

    <div *ngIf="app.menuMode === 'horizontal'">
        <h5>Topbar and Menu Mode </h5>
        <div class="field-radiobutton">
            <p-radioButton name="topbarTheme" value="light" [disabled]="app.darkMode ==='dark'" [(ngModel)]="app.topbarTheme" inputId="topbarTheme1" (onClick)="onChangeTopbar('light')"></p-radioButton>
            <label for="topbarTheme1">Light</label>
        </div>
        <div class="field-radiobutton">
            <p-radioButton name="topbarTheme" value="dark" [disabled]="app.darkMode ==='dark'" [(ngModel)]="app.topbarTheme" inputId="topbarTheme2" (onClick)="onChangeTopbar('dark')"></p-radioButton>
            <label for="topbarTheme2">Dark</label>
        </div>

        <hr />
    </div>

    <div *ngIf="app.menuMode !== 'horizontal'">
        <h5>Menu Mode </h5>
        <div class="field-radiobutton">
            <p-radioButton name="menuTheme" value="light" [disabled]="app.darkMode ==='dark'" [(ngModel)]="app.menuTheme" inputId="menuTheme1"></p-radioButton>
            <label for="menuTheme1">Light</label>
        </div>
        <div class="field-radiobutton">
            <p-radioButton name="menuTheme" value="dark" [disabled]="app.darkMode ==='dark'" [(ngModel)]="app.menuTheme" inputId="menuTheme2"></p-radioButton>
            <label for="menuTheme1">Dark</label>
        </div>

        <hr />
    </div>

    <h5>Ripple Effect</h5>
    <p-inputSwitch [ngModel]="app.ripple" (onChange)="app.onRippleChange($event)"></p-inputSwitch>

    <hr />

    <h5>Input Background</h5>
    <div class="field-radiobutton">
        <p-radioButton name="inputStyle" value="outlined" [(ngModel)]="app.inputStyle" inputId="inputStyle1"></p-radioButton>
        <label for="inputStyle1">Outlined</label>
    </div>
    <div class="field-radiobutton">
        <p-radioButton name="inputStyle" value="filled" [(ngModel)]="app.inputStyle" inputId="inputStyle2"></p-radioButton>
        <label for="inputStyle2">Filled</label>
    </div>

    <hr />

    <h5>Theme Colors</h5>
    <div class="layout-themes">
        <div *ngFor="let t of themes">
            <a style="cursor: pointer" (click)="changeTheme(t.name)" [ngStyle]="{'background-color': t.color}">
            </a>
        </div>
    </div>
</div>
